import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IScenario } from 'commonTypes/api/scenarios/scenario';

interface ScenarioState {
  currentStep: IScenario | null;
  isLoading: boolean;
  isError: boolean;
}

const initialState: ScenarioState = {
  currentStep: null,
  isLoading: false,
  isError: false,
};

export const scenarioSlice = createSlice({
  name: 'scenario',
  initialState,
  reducers: {
    setScenario: (state, action: PayloadAction<IScenario>) => {
      state.currentStep = action.payload;
      state.isLoading = false;
      state.isError = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.isError = action.payload;
    },
  },
});

export const { setScenario, setLoading, setError } = scenarioSlice.actions;
